import React from 'react'
import PropTypes from 'prop-types'
import { Card, Col, Row, Image, Button } from 'react-bootstrap';
import img from '../../assets/company_logo.png';
import styled, { css} from 'styled-components';
import CircleImage from '../CircleImage';
import MultiLineEllipse from '../MultiLineEllipse';
import parse from "html-react-parser";
import routes from '../../views/routes';

const CompanyTitle = styled.div`
    text-transform: uppercase;
    font-weight: 600;
    color: darkblue;
    text-align: center;
    margin-top:2%;
    margin-bottom:5%;
`;

const JobsButton = styled.a`
    border: none;
    background-color: #0A3BB4;
    display: flex;
    justify-content: center;
    margin: auto;
    width: max-content;
`;

const CompanyLogoConatinter = styled.div`
    width:120px;
    height:100px;
    margin-left: 30%;

    ${props =>
        props.imgUrl &&
        css`
        background-image: url(${props.imgUrl});
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
    `};
`;


function CompanyTile({ TileData, maxLine }) {

    //const imageBaseUrl='https://jobs.intellectualpoint.com/'

    return (
        <Card className='shadow'>
            <Card.Body>
                <CompanyLogoConatinter  imgUrl={TileData.CompanyLogo ? (TileData.CompanyLogo) : img} />
                <CompanyTitle> {TileData.CompanyName} </CompanyTitle>
                <MultiLineEllipse maxLine={maxLine}>
                    {TileData?.Description && parse(TileData?.Description)}
                </MultiLineEllipse>
                <JobsButton href={routes.COMPANYJOBS.replace(":companyId", TileData.CompanyId)} className='btn btn-primary'>Apply here</JobsButton>
            </Card.Body>        
        </Card> 
    )
}

CompanyTile.propTypes = {

}

export default CompanyTile;

